import React, { useContext, useEffect, useRef, useState } from 'react';
import axios from "axios";
import { connect } from 'react-redux';
import { Container, Row, Col, CardDeck, Button } from 'react-bootstrap';
import { Link, Redirect } from 'react-router-dom';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { useFailedImages } from '../../hooks/useFailedImages';

import '../App.css';

import { sceneActions } from '../../actions/scene/sceneActions.js';
import { userDataActions } from '../../actions/scene/userDataActions';
import SpinnerLoad from '../common/spinner';

import constants, { sceneCategoryTags, TAGS } from '../../const';
import SceneCard from '../scenes/scene-card';
import UploadFile from '../common/upload-file1';
import SceneUserData from '../user/scene-user-data';
import EditScene from '../scenes/edit-scene-info';
import { helper } from '../common/helper';
import PositionAdder from './position-adder.js';
import ImageGalleryView from '../gallery/image-gallery-view.js';
import DeviceSettings from '../funscript/DeviceSettings.js';
import FunscriptHeatmapComponent from '../funscript/funscriptHeatmapComponent.js';
import VideoPlayerComponent from '../funscript/VideoPlayerComponent.js';
import { useButtplugService } from '../funscript/useButtplugService.js';
import { useFunscriptAction } from '../funscript/FunscriptActionService.js';
import { TvContext } from '../../context/TvContext.js';
import SceneGarmentViewer from '../garment/scene-garment-viewer.js';

const SceneViewContainer = styled.div`
    background: linear-gradient(135deg, #f0f9fc 0%, #f3f4f6 100%);
    min-height: 100vh;
    padding: 30px 0;
    transition: background 0.3s ease;
`;

const HeaderSection = styled.div`
    background: transparent;
    color: #333;
    padding: 10px;
    margin-bottom: 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
        margin: 0;
        font-size: 42px;
        font-weight: 600;
        color: #333;
    }
`;

const ModernTabs = styled.ul`
    border-bottom: 2px solid #e0e0e0;
    display: flex;
    gap: 0;
    list-style: none;
    padding: 0;
    margin: 0 0 20px 0;

    li {
        margin: 0;
        padding: 0;

        .nav-link {
            padding: 12px 24px;
            cursor: pointer;
            font-weight: 600;
            color: #666;
            border-bottom: 3px solid transparent;
            transition: all 0.3s ease;
            position: relative;

            &:hover {
                color: #0f766e;
            }

            &.active {
                color: #0f766e;
                border-bottom-color: #0f766e;
            }
        }
    }
`;

const VideoPlayerContainer = styled.div`
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    overflow: hidden;
`;

const SidebarCard = styled.div`
    background: white;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    border-left: 4px solid;
    border-left-color: #0f766e;
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 4px 20px rgba(15, 118, 110, 0.15);
        transform: translateY(-2px);
    }
`;

const ActorsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 12px;
    margin-bottom: 16px;
`;

const ActorCard = styled(Link)`
    display: flex;
    flex-direction: column;
    text-decoration: none;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 4px 16px rgba(15, 118, 110, 0.25);
        
        img {
            filter: brightness(0.9);
        }
    }
`;

const ActorImage = styled.img`
    width: 100%;
    height: auto;
    aspect-ratio: 386 / 520;
    object-fit: cover;
    transition: filter 0.3s ease;
`;

const ActorName = styled.div`
    padding: 8px;
    background: rgba(15, 118, 110, 0.05);
    color: #0f766e;
    text-decoration: none;
    font-weight: 600;
    font-size: 12px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: background 0.2s ease;
`;

const DateText = styled.div`
    color: #999;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 16px;
`;

const SiteLink = styled(Link)`
    display: inline-flex;
    margin-right: 12px;
    margin-bottom: 12px;
    border-radius: 8px;
    overflow: hidden;
    text-decoration: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(15, 118, 110, 0.2);
    }

    .site-left-box {
        background: linear-gradient(135deg, #0f766e 0%, #06b6d4 100%);
        color: white;
        padding: 8px 12px;
        font-weight: 700;
        font-size: 12px;
        display: flex;
        align-items: center;
    }

    .site-right-box {
        background: white;
        color: #333;
        padding: 8px 12px;
        font-weight: 600;
        font-size: 12px;
    }
`;

const TagsSection = styled.div`
    background: white;
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    margin-bottom: 20px;
    margin-left: 20px;

    h3 {
        color: #333;
        font-weight: 700;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        gap: 8px;

        &::before {
            content: '';
            width: 4px;
            height: 20px;
            background: linear-gradient(135deg, #0f766e 0%, #06b6d4 100%);
            border-radius: 2px;
        }
    }
`;

const TagCategory = styled.div`
    display: grid;
    grid-template-columns: 100px 1fr;
    gap: 4px;
    margin-bottom: 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;
    }
`;

const TagCategoryLabel = styled.div`
    font-weight: 700;
    color: #0f766e;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

const TagBadgeContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
`;

const TagBadge = styled(Link)`
    display: inline-flex;
    padding: 6px 12px;
    background: linear-gradient(135deg, #0f766e 0%, #06b6d4 100%);
    color: white;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 600;
    font-size: 12px;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(15, 118, 110, 0.25);

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(15, 118, 110, 0.4);
    }
`;

const DescriptionBox = styled.div`
    background: white;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    margin-top: 20px;
    margin-bottom: 30px;
    line-height: 1.8;
    color: #555;
    font-size: 15px;
    border-left: 4px solid #06b6d4;
    white-space: pre-wrap;
`;

const ModernButton = styled.a`
    display: inline-flex;
    padding: 10px 20px;
    margin: 8px 8px 8px 0;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 600;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    align-items: center;
    gap: 8px;

    background: linear-gradient(135deg, #0f766e 0%, #06b6d4 100%);
    color: white;
    box-shadow: 0 4px 12px rgba(15, 118, 110, 0.25);

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(15, 118, 110, 0.35);
        color: white;
    }
`;

const MinimalButton = styled.button`
    background: none;
    border: none;
    color: #0f766e;
    font-weight: 600;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    cursor: pointer;
    padding: 0;
    transition: all 0.2s ease;
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 4px;

    &:hover {
        color: #06b6d4;
        opacity: 0.8;
    }
`;

const RelatedScenesContainer = styled.div`
    margin-top: 30px;
`;

const RelatedScenesTitle = styled.h3`
    color: #333;
    font-weight: 700;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 8px;

    &::before {
        content: '';
        width: 4px;
        height: 24px;
        background: linear-gradient(135deg, #e63946 0%, #f77f88 100%);
        border-radius: 2px;
    }
`;

const ScrollableSection = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 40px;
`;

const ScrollArrowButton = styled.button`
    background: linear-gradient(135deg, #0f766e 0%, #06b6d4 100%);
    border: none;
    color: white;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
    flex-shrink: 0;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(15, 118, 110, 0.2);

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(15, 118, 110, 0.3);
    }

    &:active {
        transform: translateY(0);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

const ScrollContainer = styled.div`
    display: flex;
    gap: 12px;
    overflowX: auto;
    padding-bottom: 10px;
    flex: 1;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
        height: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #f0f0f0;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #0f766e 0%, #06b6d4 100%);
        border-radius: 3px;

        &:hover {
            background: linear-gradient(135deg, #06573d 0%, #0693a0 100%);
        }
    }
`;

const ButtonGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

const FunscriptContainer = styled.div`
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    margin-bottom: 20px;

    input {
        border: 1px solid #ddd;
        border-radius: 8px;
        padding: 8px 12px;
        margin-right: 8px;
        font-size: 13px;

        &:focus {
            border-color: #0f766e;
            outline: none;
            box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.1);
        }
    }
`;

const StatusBadge = styled.div`
    display: inline-flex;
    padding: 8px 16px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-right: 8px;
    margin-bottom: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`;

function SceneView(props) {
    var utc = require('dayjs/plugin/utc')
    dayjs.extend(utc)

    const { tvState, setTvState } = useContext(TvContext);

    const { getScene, getSceneTag } = props;
    const [openPositions, setOpenPositions] = useState(true);
    const [scenePositions, setScenePositions] = useState([]);
    const [funscript, setFunscript] = useState({});
    const [errorFlag, setErrorFlag] = useState(false);
    const [tab, setTab] = useState(0);
    const [currentVideoTime, setCurrentVideoTime] = useState(0);
    const hasSceneTag = (tagId) => props.sceneTag.some(e => String(e.id) === String(tagId));

    // Use the custom hook for failed image tracking
    const { createImageErrorHandler } = useFailedImages();

    // 0 - Scene
    // 1 - Gallery


    const {
        connectionState,
        devices,
        connectToExternalServer,
        connectToLocalServer,
        disconnect,
        startScanning,
        stopScanning,
        getDevices,
    } = useButtplugService();

    const {
        loadFunscript,

        findActionIndexForTime,
        dispatchAction,
        reset,
        checkTime,
        funscriptDuration,
        currentFunscript, actions } = useFunscriptAction();


    const vidRef = useRef(null)
    var token = `?token=${localStorage.getItem('token').slice(7)}`;

    const fetchScenePositions = () => {
        axios.get(`${constants.DATA1_API_URL}/scene/${parseInt(props.match.params.id)}/positions`).then((res) => {
            setScenePositions(res.data)

        })
    }

    const fetchFunscript = async () => {
        await axios.get(`${constants.CONTENT_DOMAIN}dload/${props.scene.scene.scene.videoUrl?.replace('stream/', '').replace('.mp4', '.funscript')}${token}`)
            .then((res) => {
                setFunscript(res.data)
                loadFunscript(res.data)
            })
    }

    const printFunscript = () => {
        console.log('actions from Scene', actions);
        console.log('Devices from scene', getDevices());
    }


    const collapseFunc = () => {
        if (openPositions === true)
            setOpenPositions(false);
        else
            setOpenPositions(true);
    }

    useEffect(() => {
        fetchScenePositions();
        getScene(parseInt(props.match.params.id));
        // await fetchFunscript()
        getSceneTag(parseInt(props.match.params.id));
        return () => { };
        // eslint-disable-next-line
    }, [props.match.params.id]);



    useEffect(() => {
        getCurrentTime();
        const videoElement = document.getElementById("sceneVideo");

        const handleTimeUpdate = () => {
            if (videoElement) {
                setCurrentVideoTime(videoElement.currentTime);
            }
        };

        if (videoElement) {
            videoElement.addEventListener('timeupdate', handleTimeUpdate);
            return () => {
                videoElement.removeEventListener('timeupdate', handleTimeUpdate);
            };
        }
        // eslint-disable-next-line
    }, [])

    const updateErrorFlag = () => {
        setErrorFlag(true);
        props.flagScene(props.scene.scene.scene.id)
        props.getScene(props.scene.scene.scene.id);
    }
    const getCurrentTime = () => {
        var vid = document.getElementById("sceneVideo");
        props.addToHistory(parseInt(props.match.params.id), vid.currentTime);
    };

    const jumpVideo = (value) => {
        console.log('Jumping video to:', value);
        if (vidRef.current) {
            vidRef.current.currentTime = value;
        }
        var vid = document.getElementById(`sceneVideo`);
        if (vid) {
            vid.currentTime = value;
        }
    }

    const scrollRefs = {
        movie: useRef(null),
        model: useRef(null),
        site: useRef(null)
    };

    const handleScroll = (refKey, direction) => {
        const container = scrollRefs[refKey].current;
        if (container) {
            const scrollAmount = 300;
            if (direction === 'left') {
                container.scrollLeft -= scrollAmount;
            } else {
                container.scrollLeft += scrollAmount;
            }
        }
    };

    const RelatedScenes = () => {
        var relatedScenes = [];
        if (props.relScenes.movie.count > 0) {
            var movieSceneCard = [];
            props.relScenes.movie.scenes.forEach(scene => {
                movieSceneCard.push(<CardDeck key={scene.scene.id} className="relcard"><SceneCard scene={scene} /></CardDeck>);
            });
            relatedScenes.push(
                <div key="movie-0">
                    <RelatedScenesTitle>{`${props.relScenes.movie.count} Scenes in ${props.scene.movie.title}`}</RelatedScenesTitle>
                    <ScrollableSection>
                        <ScrollArrowButton onClick={() => handleScroll('movie', 'left')}>←</ScrollArrowButton>
                        <ScrollContainer ref={scrollRefs.movie} className="scrollcards">{movieSceneCard}</ScrollContainer>
                        <ScrollArrowButton onClick={() => handleScroll('movie', 'right')}>→</ScrollArrowButton>
                    </ScrollableSection>
                </div>);
        }
        if (props.relScenes.models.length > 0) {
            var relScenes = [];
            props.relScenes.models.forEach(model => {
                var modelSceneCard = [];
                model.scenes.forEach(scene => {
                    modelSceneCard.push(<CardDeck key={scene.scene.id} className="relcard"><SceneCard scene={scene} /></CardDeck>);
                });
                relScenes.push(
                    <div key={`model-${model.models[0].name}`}>
                        <RelatedScenesTitle>{`${model.count} Scenes with ${model.models[0].name}`}</RelatedScenesTitle>
                        <ScrollableSection>
                            <ScrollArrowButton onClick={() => handleScroll('model', 'left')}>←</ScrollArrowButton>
                            <ScrollContainer ref={scrollRefs.model} className="scrollcards">{modelSceneCard}</ScrollContainer>
                            <ScrollArrowButton onClick={() => handleScroll('model', 'right')}>→</ScrollArrowButton>
                        </ScrollableSection>
                    </div>)
            });
            relatedScenes.push(relScenes);
        }
        if (props.relScenes.site.count > 0) {
            var siteSceneCard = [];
            props.relScenes.site.scenes.forEach(scene => {
                siteSceneCard.push(<CardDeck key={scene.scene.id} className="relcard"><SceneCard scene={scene} /></CardDeck>);
            });
            relatedScenes.push(
                <div key="site-0">
                    <RelatedScenesTitle>{`${props.relScenes.site.count} Scenes from ${props.scene.site.name}`}</RelatedScenesTitle>
                    <ScrollableSection>
                        <ScrollArrowButton onClick={() => handleScroll('site', 'left')}>←</ScrollArrowButton>
                        <ScrollContainer ref={scrollRefs.site} className="scrollcards">{siteSceneCard}</ScrollContainer>
                        <ScrollArrowButton onClick={() => handleScroll('site', 'right')}>→</ScrollArrowButton>
                    </ScrollableSection>
                </div>);
        }
        return relatedScenes
    }



    if (!props.isFetching) {
        document.title = `${props.scene.scene.scene.id}|${props.scene.scene.scene.title}`;
    }

    const SectionTitle = styled.h4`
    color: #333;
    font-weight: 700;
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 16px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
    gap: 8px;

    &::before {
        content: '';
        width: 4px;
        height: 20px;
        background: linear-gradient(135deg, #0f766e 0%, #06b6d4 100%);
        border-radius: 2px;
    }
`;

    return (<>
        {!props.isFetching ?
            <SceneViewContainer>
                <Container style={{ maxWidth: `${window.innerWidth}px` }}>
                    {props.scene.scene.scene.id === 0 && props.error !== '' ? <Redirect to='/scenes'></Redirect> : <></>}
                    <Container>
                        <HeaderSection>
                            <h2>{props.scene.scene.scene.title}</h2>
                            <SceneUserData sceneId={props.match.params.id}></SceneUserData>
                        </HeaderSection>

                        <ModernTabs className="nav nav-tabs">
                            <li className="nav-item">
                                <div className={`nav-link ${tab == 0 ? 'active' : ''}`} onClick={() => setTab(0)}>Scene</div>
                            </li>
                            {props.scene.scene.scene.gallery ?
                                <li className="nav-item">
                                    <div className={`nav-link ${tab == 1 ? 'active' : ''}`} onClick={() => setTab(1)}>Gallery</div>
                                </li> : null}
                        </ModernTabs>
                        {tab == 0 ?
                            <Row className="justify-content-between" style={{ width: '100%' }}>
                                <VideoPlayerContainer style={{ width: "100%" }}>
                                    {!props.isFetchingSceneTag ?
                                        <VideoPlayerComponent id="sceneVideo" ref={vidRef}
                                            sourceUrl={`${constants.CONTENT_DOMAIN}${props.scene.scene.scene.videoUrl}${token}#t=${props.startTime}`}
                                            posterUrl={`${constants.TRAILER_CDN}${props.scene.scene.scene.posterUrl}${token}`}
                                            isVR={hasSceneTag(469) || hasSceneTag(459)}
                                            vrType={props.scene.scene.scene.vrType}
                                            script={hasSceneTag(649)}
                                            getCurrentTime={getCurrentTime}
                                        /> : null}
                                </VideoPlayerContainer>

                                {hasSceneTag(649) ? <>
                                    <FunscriptContainer style={{ width: "100%" }}>
                                        {!props.isFetchingUserInfo & !props.isFetching ? (
                                            <FunscriptHeatmapComponent funscriptUrl={`${constants.CONTENT_DOMAIN}dload/${props.scene.scene.scene.videoUrl?.replace('stream/', '').replace('.mp4', '.funscript')}${token}`} widthPx={'100%'} heightPx={'75px'} />) : null}
                                        <input placeholder="Script Timing Offset (ms)" defaultValue={tvState.deviceSettings.scriptTimingOffsetMs}
                                            onChange={(e) => setTvState({
                                                ...tvState,
                                                deviceSettings: {
                                                    ...tvState.deviceSettings,
                                                    scriptTimingOffsetMs: parseInt(e.target.value)
                                                }
                                            })} />
                                        <MinimalButton onClick={fetchFunscript}>Refresh Funscript</MinimalButton>
                                        <MinimalButton onClick={() => { printFunscript(); console.log(tvState.deviceSettings) }}>Print Funscript</MinimalButton>
                                    </FunscriptContainer>
                                </> : null}
                            </Row>
                            : null}




                        {tab == 1 && props.scene.scene.scene.gallery ?
                            <Row style={{ width: '100%' }}>
                                <VideoPlayerContainer style={{ width: "100%" }}>
                                    <ImageGalleryView id={props.scene.scene.scene.gallery.split('/')[0]} params={{
                                        album: props.scene.scene.scene.gallery.split('/')[1],
                                        displayAlbum: false
                                    }} />
                                </VideoPlayerContainer>
                            </Row>
                            : null}

                        {scenePositions.length > 0 ?
                            <>
                                <div style={{ width: '100%', marginTop: '0px', marginBottom: '0px' }}>
                                    <MinimalButton onClick={collapseFunc}>
                                        {!openPositions ? <SectionTitle>▷ Positions</SectionTitle> : <SectionTitle>▼ Positions</SectionTitle>}
                                    </MinimalButton>
                                </div>
                                <Row style={{ width: '100%' }}>
                                    {openPositions ? <PositionAdder editMode={false} sceneId={props.match.params.id} jumpVideo={jumpVideo} scenePositions={scenePositions} /> : null}
                                </Row>
                            </>
                            : null}

                        <Row style={{ width: '100%', marginTop: '30px', gap: '20px' }}>
                            <Col sm={3} md={3}>
                                <SidebarCard>
                                    <ActorsContainer>
                                        {props.scene.actors.map((actor, index) =>
                                            <ActorCard key={index} to={`/actor/${actor.id}`}>
                                                <ActorImage
                                                    src={`${constants.CONTENT_DOMAIN}download/sus-media/actors/${String(actor.id).padStart(4, '0')}/model-large.webp${token}`}
                                                    alt={actor.name}
                                                    onError={createImageErrorHandler(
                                                        `/${actor.sexe}-large.webp`
                                                    )}
                                                />
                                                <ActorName>{actor.name}</ActorName>
                                            </ActorCard>
                                        )}
                                    </ActorsContainer>
                                    <DateText>{dayjs(props.scene.scene.scene.date).format("D-MMM-YYYY")}</DateText>
                                    <div>
                                        <SiteLink to={`/scenes?site=${props.scene.site.siteId}`} className="site site-scene">
                                            <div className="site-left-box site">{props.scene.site.shortname}</div>
                                            <div className="site-right-box site">{props.scene.site.name}</div>
                                        </SiteLink>
                                        {props.scene.movie.id !== 0 ?
                                            <SiteLink to={`/movie/${props.scene.movie.id}`} className="site site-scene">
                                                <div className="site-left-box site">{props.scene.movie.scenesNumber}</div>
                                                <div className="site-right-box site">{props.scene.movie.title}</div>
                                            </SiteLink>
                                            : null}
                                    </div>
                                </SidebarCard>
                            </Col>

                            <Col sm={9} md={8}>
                                <TagsSection>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                        <h3 style={{ margin: 0 }}>Tags & Wardrobe</h3>
                                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                            <SceneGarmentViewer sceneId={props.scene.scene.scene.id} />
                                            {props.perms.some(e => e.role.id === 12) ? <UploadFile sceneId={props.scene.scene.scene.id} /> : null}
                                            {props.perms.some(e => e.role.id === 2) ? <EditScene sceneView={true} sceneId={props.scene.scene.scene.id} /> : null}
                                        </div>
                                    </div>
                                    {!props.isFetchingSceneTag ? sceneCategoryTags.map((cat, idx) => (
                                        <TagCategory key={`${cat}${idx}`}>
                                            <TagCategoryLabel>{cat}</TagCategoryLabel>
                                            <TagBadgeContainer>
                                                {console.log(props.sceneTag)}
                                                {helper.findTag(TAGS.SCENECATEGORY, cat, props.sceneTag).map((tag) =>
                                                    <TagBadge key={tag.id} to={`/scenes?tag=${tag.id}`}>{tag.name}</TagBadge>
                                                )}
                                            </TagBadgeContainer>
                                        </TagCategory>
                                    )) : <SpinnerLoad />}
                                </TagsSection>
                            </Col>
                        </Row>

                        <DescriptionBox>
                            {props.scene.scene.scene.description}
                        </DescriptionBox>

                        <div style={{ marginBottom: '30px' }}>
                            <ButtonGroup>
                                <a href={`${constants.CONTENT_DOMAIN}dload/${props.scene.scene.scene.videoUrl?.replace('stream/', '')}${token}`} onClick={() => props.downloadHistory(props.scene.scene.scene.id)} style={{ color: '#0f766e', textDecoration: 'underline', fontWeight: 600, fontSize: 13, textTransform: 'uppercase', letterSpacing: '0.5px', cursor: 'pointer' }}>
                                    Download Video
                                </a>
                                {hasSceneTag(649) ?
                                    <a href={`${constants.CONTENT_DOMAIN}dload/${props.scene.scene.scene.videoUrl?.replace('stream/', '').replace('.mp4', '.funscript')}${token}`} onClick={() => props.downloadHistory(props.scene.scene.scene.id)} style={{ color: '#0f766e', textDecoration: 'underline', fontWeight: 600, fontSize: 13, textTransform: 'uppercase', letterSpacing: '0.5px', cursor: 'pointer', marginLeft: '15px' }}>
                                        Download Funscript
                                    </a>
                                    : null}
                                {props.scene.scene.scene.statusName !== 'COM' & props.scene.scene.scene.statusName !== 'UE' ?
                                    <StatusBadge style={{
                                        background: props.scene.scene.scene.statusName === 'REF' | props.scene.scene.scene.statusName === 'IPI' ? '#fff3cd' : '#f8d7da',
                                        color: props.scene.scene.scene.statusName === 'REF' | props.scene.scene.scene.statusName === 'IPI' ? '#856404' : '#721c24',
                                        marginLeft: '15px'
                                    }}>
                                        {props.scene.scene.scene.statusName === 'REF' | props.scene.scene.scene.statusName === 'IPI' ? 'Partial metadata' : 'Missing'}
                                    </StatusBadge>
                                    : null}
                                {props.scene.scene.scene.statusName !== 'UE' ?
                                    <MinimalButton onClick={updateErrorFlag} style={{ marginLeft: '15px' }}>Flag Missing Video</MinimalButton>
                                    :
                                    <StatusBadge style={{ background: '#f8d7da', color: '#721c24', marginLeft: '15px' }}>Missing Video, Already Flagged!</StatusBadge>
                                }
                            </ButtonGroup>
                        </div>

                        <RelatedScenesContainer>
                            <RelatedScenes />
                        </RelatedScenesContainer>
                    </Container>
                </Container>
            </SceneViewContainer>
            : <SpinnerLoad></SpinnerLoad>}
    </>
    )
}

const mapStateToProps = (state) => {
    return {
        isFetching: state.sceneReducers.isFetching,
        scene: state.sceneReducers.scene,
        error: state.sceneReducers.error,

        isFetchingSceneTag: state.sceneReducers.isFetchingSceneTag,
        sceneTag: state.sceneReducers.sceneTag,
        tags: state.sceneReducers.tags,

        relScenes: state.sceneReducers.relatedScenes,

        allStatus: state.scenes.status.allStatus,
        startTime: state.scenes.userData.history.time,
        perms: state.users.permissions.perms
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getScene: (id) => dispatch(sceneActions.getScene(id)),
        getSceneTag: (id) => dispatch(sceneActions.getSceneTag(id)),
        getRelatedScene: ((site, model, movie) => dispatch(sceneActions.getRelatedSceneCard(10, 1, site, "date", "desc", model, "", movie))),
        addToHistory: (id, time) => dispatch(userDataActions.addHistoryScene(id, time)),
        downloadHistory: (id) => dispatch(sceneActions.downloadSceneHistory(id)),
        flagScene: (id) => dispatch(sceneActions.flagSceneError(id))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SceneView);